import clip from "text-clipper";

/**
 * Checks if a string with html tags has text content
 * Checks if the string contains media content (image, video, iframe, etc)
 */
export const isStringWithContent = (stringWithHtmlTags: string): boolean => {
  // get the text content without html tags
  // check if the html content contains a single empty tag (ex: <p></p>)
  const stringWithoutTags = clip(
    stringWithHtmlTags,
    stringWithHtmlTags?.length,
    {
      html: true,
      stripTags: true,
    }
  );

  // check that text content has characters other than spaces
  // check if text content contains any images or videos (need this to display media if there is no text)
  return (
    stringWithoutTags?.trim()?.length > 0 ||
    stringWithHtmlTags.includes("<img") ||
    stringWithHtmlTags.includes("<video") ||
    stringWithHtmlTags.includes("<iframe")
  );
};

export const getTruncatedText = (text: string, length = 20): string => {
  let returnText = text;
  if (text.length > length) {
    returnText = `${text.substring(0, length)}...`;
  }
  return returnText;
};
